/**
 * Stable TanStack Query key factory for LoRA hooks (Phase 06).
 *
 * Single source of truth for query keys; consumers MUST import these to
 * keep invalidations + cache reads consistent. Mirrors the factory style
 * used by `useBillingContext`.
 */

import type { ListLorasFilters } from "../../types/loras";

export const loraQueryKeys = {
  all: ["loras"] as const,
  lists: () => [...loraQueryKeys.all, "list"] as const,
  list: (filters?: ListLorasFilters) =>
    [...loraQueryKeys.lists(), filters ?? null] as const,
  details: () => [...loraQueryKeys.all, "detail"] as const,
  detail: (loraId: string) => [...loraQueryKeys.details(), loraId] as const,
  checkpoints: (loraId: string) =>
    [...loraQueryKeys.detail(loraId), "checkpoints"] as const,
  trainingRuns: (loraId: string) =>
    [...loraQueryKeys.detail(loraId), "training-runs"] as const,
  datasetPrep: (loraId: string) =>
    [...loraQueryKeys.detail(loraId), "dataset-prep"] as const,
  baseModels: () => ["lora-base-models"] as const,
  kinds: () => ["lora-kinds"] as const,
};

export const trainingRunQueryKeys = {
  all: ["training-runs"] as const,
  detail: (trainingRunId: string) =>
    [...trainingRunQueryKeys.all, trainingRunId] as const,
};
